import React, { Fragment } from 'react';
import { View } from 'react-native';
import T from 'prop-types';
import { useIntl } from 'react-intl';

import {
  FLEX_DRAFT_SCHEDULE_BI_WEEKLY,
  FLEX_DRAFT_SCHEDULE_SELECT_LIST,
  FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY,
} from '@dmi/shared/redux/Payments/FlexDraft/constants';

import {
  FormattedMessage,
  H3,
  KeyboardAvoidingScrollView,
  P3,
} from '../../../base_ui';
import { SecondaryHeader } from '../../../ScreenHeaders';
import {
  FlexContainer,
  SelectButtonWrapper,
  SelectCardContent,
  SelectRowContainer,
  SelectTextContainer,
  StyledDivider,
  StyledIconButton,
  StyledLargePrimaryButton,
  StyledP3,
} from './styledComponents';
import iconDictionary from '../../../../utils/iconDictionary';

const CheckedIcon = iconDictionary('approved');
const UncheckedIcon = iconDictionary('unapproved');

const ScheduleSelect = ({
  dispatchChangeInput,
  dispatchResetFormState,
  dispatchSetSelectedDraftScheduleStep,
  formValues: { draftSchedule },
  navigation,
}) => {
  const { formatMessage } = useIntl();

  const handleOnPressDraftSchedule = (value) => {
    // When changing the selected draft schedule, reset both form states
    [FLEX_DRAFT_SCHEDULE_BI_WEEKLY, FLEX_DRAFT_SCHEDULE_SEMI_MONTHLY]
      .forEach((form) => dispatchResetFormState({ form }));
    dispatchChangeInput({
      field: 'draftSchedule',
      form: 'scheduleSelect',
      value,
    });
  };

  const handleOnPressNextStep = () => {
    dispatchSetSelectedDraftScheduleStep({ step: draftSchedule });
    navigation.navigateDeprecated('FlexDraftScheduleSet');
  };

  return (
    <Fragment>
      <SecondaryHeader
        handleBack={() => navigation.navigateDeprecated('FlexDraftSetupOverview')}
        title="Select Payment Schedule"
      />
      <KeyboardAvoidingScrollView scrollViewProps={{ showsVerticalScrollIndicator: false }}>
        <SelectCardContent>
          <FlexContainer>
            <StyledDivider />
            {FLEX_DRAFT_SCHEDULE_SELECT_LIST.map(({
              description: { mobileText },
              label,
              value,
            }) => {
              const isChecked = draftSchedule === value;
              return (
                <View key={value}>
                  <SelectRowContainer>
                    <StyledIconButton
                      ariaLabel={`${label} radio button, ${isChecked ? 'checked' : 'unchecked'}`}
                      Icon={isChecked ? CheckedIcon : UncheckedIcon}
                      onPress={() => handleOnPressDraftSchedule(value)}
                    />
                    <SelectTextContainer>
                      <H3>{label}</H3>
                      <FormattedMessage
                        defaultMessage={formatMessage({ id: mobileText })}
                        values={{
                          // eslint-disable-next-line react/prop-types
                          p: ({ msg }) => <StyledP3>{msg}</StyledP3>,
                        }}
                        WrapperComponent={P3}
                      />
                    </SelectTextContainer>
                  </SelectRowContainer>
                  <StyledDivider />
                </View>
              );
            })}
          </FlexContainer>
        </SelectCardContent>
      </KeyboardAvoidingScrollView>
      <SelectButtonWrapper>
        <StyledLargePrimaryButton
          label="Next Step"
          onPress={handleOnPressNextStep}
        />
      </SelectButtonWrapper>
    </Fragment>
  );
};
ScheduleSelect.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchResetFormState: T.func.isRequired,
  dispatchSetSelectedDraftScheduleStep: T.func.isRequired,
  formValues:
    T.shape({ draftSchedule: T.string.isRequired }).isRequired,
  navigation: T.object.isRequired,
};

export default ScheduleSelect;
